import React, { useState, useEffect } from "react";
import { makeStyles, tokens, Text, Button } from "@fluentui/react-components";
import { Card, CardProps } from "@fluentui/react-components";
import { Stack } from "@fluentui/react";
import img from "./image.png";
import { IconButton } from "@fluentui/react";
import { useDispatch } from "react-redux";
import {
  SETChileComponentName,
  SETHasServiceRequestTypeLogData,
  SETIsCustomeLog,
  SETLogEventData,
  SETServiceRequestTypeLogData,
  getIsUserDataUpdated,
  setIsBotError,
  setIsLoader,
  setPreferenceChanged,
  setRecommendedTiles,
  settitleLoaderName,
  SetIsWwicCopilot,
} from "../../../../../core/store";

import CardModal from "../CardModal";  // Importing the modal component

const CardElements = (
  props: CardProps & {
    title: string;
    aboutService: string;
    displayName: string;
    isExpanded: boolean;
    toggleExpand: () => void;
    onDelete: () => void;
    onClick: () => void;
  }
) => {
  const styles = useStyles();
  const words = props.aboutService.split(" ");
  const isLong = words.length > 10;
  const truncatedText = isLong
    ? words.slice(0, 10).join(" ") + "..."
    : props.aboutService;

  return (
    <Card className={styles.cardcomp} {...props} onClick={props.onClick}>
      <div className={styles.headerconatiner}>
        <Text className={styles.title}>{props.title}</Text>
        <Text className={styles.description}>
          {props.aboutService}
        </Text>
      </div>
      <div className={styles.infoSection}>
        <Stack wrap horizontal tokens={{ childrenGap: 50 }}>
          <Stack horizontal tokens={{ childrenGap: 10 }} className={styles.leftColumn}>
            <p>
              <strong>Help Provider: </strong>
              <br />
              Global Ticket System
            </p>
          </Stack>
          <Stack horizontal tokens={{ childrenGap: 8 }} className={styles.rightColumn}>
            <img alt="icon" className={styles.iconImage} src={img} />
          </Stack>
        </Stack>
      </div>
      <div className={styles.leftColSla}>
        <p>
          <strong>SLA | Owner</strong>
        </p>
        <p>3 days | {props.displayName}</p>
      </div>
      {/* 
      <div className={styles.actionconatiner}>
        <Stack wrap horizontal tokens={{ childrenGap: 8 }}>
          <Stack horizontal tokens={{ childrenGap: 8 }} style={{ margin: "30px 30px 50px 0px", fontWeight: "bold" }}>
            Types of Helps
          </Stack>
          <Stack>
            <Button className={styles.actionButton}>Information</Button>
            <Button className={styles.actionButton}>Troubleshooting</Button>
            <Button className={styles.actionButton}>Services</Button>
            <Button className={styles.actionButton}>Actions</Button>
          </Stack>
        </Stack>
      </div> */}
      <IconButton
        iconProps={{ iconName: "Delete" }}
        aria-label="Delete"
        className={styles.deleteIcon}
        onClick={(e) => {
          e.stopPropagation(); // This prevents the card's onClick handler from being triggered
          props.onDelete(); // Trigger the delete function
        }}
      />
    </Card>
  );
};

export const CardContainer = ({ setActiveTabKey, setShowBot, setChatBotClicked, setIrisUtterance,setTileName,setIrisAppName,currentUserData }) => {
  const styles = useStyles();
  const [cards, setCards] = React.useState([]);
  const [expandedCards, setExpandedCards] = React.useState({});
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  const [defaultTab, setDefaultTab] = useState("service");

  const mockData =[
    {
      "id": 548,
      "userID": 12970,
      "serviceID": 67,
      "iriS_Utterance": "Account Management Requests",
      "tileName": "Account Management Requests",
      "name": "Account Management Requests",
      "aboutService": "Get Support for maintaining account data accuracy in SPM to ensure effective segmentation and governance",
      "dataverseRowID": "ad94597a-c7bb-ef11-a72f-000d3a59cf44",
      "service_IsActive": true,
      "service_IsDropdownUI": false,
      "service_IsNonIRISService": false,
      "service_IsPrivate": false,
      "serviceDropDownLinks": null,
      "serviceRequestFormLink": "[{\"RequestTypeName\":\"Create and/or Link CRM ID to MSSalesID\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Demote Parent to Child test\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Move Child to New Parent Test\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Process Approved Segmentation Changes\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Process Fiscal Year Parenting Requests\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Promote Child to Parent\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Request General Account Management Support\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false}]",
      "openinBrowserTab": false,
      "relatedInformation": null,
      "serviceCategories": null,
      "service_IsLarge": 0,
      "upn": "44bca750-9251-ee11-be6f-00224804c8f6",
      "displayName": "Vanshika Patel",
      "faqLink": null,
      "irisAppName": "mcapsv2",
      "requestTypeName": null,
      "defaultloadtile": false,
      "isSegment": true
  },
    {
        "id": 73929,
        "userID": 31162,
        "serviceID": 21,
        "iriS_Utterance": null,
        "tileName": "Agreement Management ",
        "name": "Agreement Management",
        "aboutService": "Get Support for managing agreements, accessing billing information, and requesting tool access with Agreement Management",
        "dataverseRowID": "2d8fa2dd-c7d7-ef11-a72f-000d3a59cf44",
        "service_IsActive": true,
        "service_IsDropdownUI": false,
        "service_IsNonIRISService": false,
        "service_IsPrivate": false,
        "serviceDropDownLinks": null,
        "serviceRequestFormLink": "[{\"RequestTypeName\":\"Access Request\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Others-Braavos\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false}]",
        "openinBrowserTab": false,
        "relatedInformation": null,
        "serviceCategories": null,
        "service_IsLarge": 0,
        "upn": "3de6d199-49ab-ea11-a812-000d3a35b29b",
        "displayName": "Abhishek Kumar",
        "faqLink": null,
        "irisAppName": "mcapsv2",
        "requestTypeName": null,
        "defaultloadtile": false,
        "isSegment": false
    },
    {
        "id": 73930,
        "userID": 31162,
        "serviceID": 90,
        "iriS_Utterance": null,
        "tileName": "AMM Offer Navigator",
        "name": "AMM Offer Navigator",
        "aboutService": "Get support for technical queries and functionality issues related to the AMM Offer Navigator",
        "dataverseRowID": "aae936c9-c8d7-ef11-a72f-6045bd08c04e",
        "service_IsActive": true,
        "service_IsDropdownUI": false,
        "service_IsNonIRISService": false,
        "service_IsPrivate": false,
        "serviceDropDownLinks": null,
        "serviceRequestFormLink": "[{\"RequestTypeName\":\"Access Request\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Technical Issues or Bugs\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Tool or Field Updates\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"User Access Issues\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false}]",
        "openinBrowserTab": false,
        "relatedInformation": null,
        "serviceCategories": null,
        "service_IsLarge": 0,
        "upn": "fb7b64cf-e121-e911-a824-000d3a31272e",
        "displayName": "Someshwar Sharma",
        "faqLink": null,
        "irisAppName": "mcapsv2",
        "requestTypeName": null,
        "defaultloadtile": false,
        "isSegment": false
    },
      {
        "id": 854,
        "userID": 12970,
        "serviceID": 165,
        "iriS_Utterance": "Digital Win Room (DWR) Help",
        "tileName": "Digital Win Room (DWR) Help",
        "name": "Digital Win Room (DWR) Help",
        "aboutService": "Get support with Executive DWR and Office Hours Calendars, DWR Suite & Top Deals Report",
        "dataverseRowID": "f4c6be1c-ebc9-ef11-a72e-000d3a5ac34e",
        "service_IsActive": true,
        "service_IsDropdownUI": false,
        "service_IsNonIRISService": false,
        "service_IsPrivate": false,
        "serviceDropDownLinks": null,
        "serviceRequestFormLink": "[{\"RequestTypeName\":\"Bug\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Business Queries\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Data Queries\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Meeting Logistics\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Other\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false}]",
        "openinBrowserTab": false,
        "relatedInformation": null,
        "serviceCategories": null,
        "service_IsLarge": 0,
        "upn": "035dcbcc-6547-ec11-8f8e-0022480a91af",
        "displayName": "Angie Shaeffer",
        "faqLink": null,
        "irisAppName": "mcapsv2",
        "requestTypeName": null,
        "defaultloadtile": false,
        "isSegment": false
    },
    {
        "id": 73933,
        "userID": 31162,
        "serviceID": 72,
        "iriS_Utterance": "Annuity and Renewal Requests",
        "tileName": "Annuity and Renewal Requests",
        "name": "Annuity and Renewal Requests",
        "aboutService": "Get Support for correcting inaccurate renewal data of EA or EAS renewals with Annuity & Renewal Requests",
        "dataverseRowID": "8927d5d0-c8d7-ef11-a72f-000d3a35c3b5",
        "service_IsActive": true,
        "service_IsDropdownUI": false,
        "service_IsNonIRISService": false,
        "service_IsPrivate": false,
        "serviceDropDownLinks": null,
        "serviceRequestFormLink": "[{\"RequestTypeName\":\"Allocation\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Fix Incorrect Renewal Data\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Request Annuity and Renewal Support\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false}]",
        "openinBrowserTab": false,
        "relatedInformation": null,
        "serviceCategories": null,
        "service_IsLarge": 0,
        "upn": "779b90cc-5522-e911-a824-000d3a31272e",
        "displayName": "Aneetha Oberoi",
        "faqLink": null,
        "irisAppName": "mcapsv2",
        "requestTypeName": null,
        "defaultloadtile": false,
        "isSegment": true
    },
    {
        "id": 73932,
        "userID": 31162,
        "serviceID": 112,
        "iriS_Utterance": null,
        "tileName": "Area Win Room Intake Request",
        "name": "Area Win Room Intake Request",
        "aboutService": "Get Support for simplifying the ECIF pre-approval process and prioritizing requests before submission to OneAsk",
        "dataverseRowID": "f03ffdd5-c8d7-ef11-a72f-000d3a3716d1",
        "service_IsActive": true,
        "service_IsDropdownUI": false,
        "service_IsNonIRISService": true,
        "service_IsPrivate": false,
        "serviceDropDownLinks": null,
        "serviceRequestFormLink": "https://uatracker.microsoft.com/createaction/corp?team=mcaps%20ecif%20pre-approval&region=Asia",
        "openinBrowserTab": false,
        "relatedInformation": null,
        "serviceCategories": null,
        "service_IsLarge": 0,
        "upn": "99731051-a822-e911-a824-000d3a31272e",
        "displayName": "Stephanie Wilson",
        "faqLink": null,
        "irisAppName": "mcapsv2",
        "requestTypeName": null,
        "defaultloadtile": false,
        "isSegment": false
    },
    {
        "id": 73931,
        "userID": 31162,
        "serviceID": 134,
        "iriS_Utterance": "Area Win Room Services Japan",
        "tileName": "Area Win Room Services Japan",
        "name": "Area Win Room Services Japan",
        "aboutService": "Get Support for Area Win Room Services",
        "dataverseRowID": "34abb3dd-00d8-ef11-a72f-000d3a5d2863",
        "service_IsActive": true,
        "service_IsDropdownUI": false,
        "service_IsNonIRISService": false,
        "service_IsPrivate": false,
        "serviceDropDownLinks": null,
        "serviceRequestFormLink": "[{\"RequestTypeName\":\"AWR会議室予約\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"OneNote/OneAsk/ASOチェック\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"SOW作成\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"内部/クライアントトレーニング\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"申請内容、ROI、SOWチェック\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"電話/チャット/メールにて申請者やクライアントと連絡\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false}]",
        "openinBrowserTab": false,
        "relatedInformation": null,
        "serviceCategories": null,
        "service_IsLarge": 0,
        "upn": "12047460-8420-e911-a823-000d3a31272e",
        "displayName": "Jolly Yeung",
        "faqLink": null,
        "irisAppName": "mcapsv2",
        "requestTypeName": null,
        "defaultloadtile": false,
        "isSegment": false
    },
    {
        "id": 73935,
        "userID": 31162,
        "serviceID": 161,
        "iriS_Utterance": "Audits and Compliance Requests",
        "tileName": "Audits and Compliance Requests",
        "name": "Audits and Compliance Requests",
        "aboutService": "Get support on completion of audit related activities like invoicing, cross-checking, extracts from CompassOne etc",
        "dataverseRowID": "1f472753-caea-ef11-be21-000d3a36150e",
        "service_IsActive": true,
        "service_IsDropdownUI": false,
        "service_IsNonIRISService": false,
        "service_IsPrivate": false,
        "serviceDropDownLinks": null,
        "serviceRequestFormLink": null,
        "openinBrowserTab": false,
        "relatedInformation": null,
        "serviceCategories": null,
        "service_IsLarge": 0,
        "upn": "e496b9fe-dd22-e911-a824-000d3a31272e",
        "displayName": "MARGARITA Nikoletatou",
        "faqLink": null,
        "irisAppName": "mcapsv2",
        "requestTypeName": null,
        "defaultloadtile": false,
        "isSegment": false
    },
    {
        "id": 73934,
        "userID": 31162,
        "serviceID": 47,
        "iriS_Utterance": "Americas Requests",
        "tileName": "Awards-Contests and Incentive Requests",
        "name": "Awards-Contests and Incentive Requests",
        "aboutService": "Get Support related to submitting requests for contests, Incentive program & Morale events",
        "dataverseRowID": "5a06d4de-c8d7-ef11-a72f-000d3a59cf44",
        "service_IsActive": true,
        "service_IsDropdownUI": false,
        "service_IsNonIRISService": false,
        "service_IsPrivate": false,
        "serviceDropDownLinks": null,
        "serviceRequestFormLink": "[{\"RequestTypeName\":\"Contest\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Incentive Program\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Morale Event\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false}]",
        "openinBrowserTab": false,
        "relatedInformation": null,
        "serviceCategories": null,
        "service_IsLarge": 0,
        "upn": "b4d703d7-88ec-ec11-bb3d-0022480b78af",
        "displayName": "Amit Desai",
        "faqLink": null,
        "irisAppName": "mcapsv2",
        "requestTypeName": null,
        "defaultloadtile": false,
        "isSegment": false
    },
    {
        "id": 52187,
        "userID": 31162,
        "serviceID": 35,
        "iriS_Utterance": null,
        "tileName": "ECIF Support Services",
        "name": "ECIF Support Services",
        "aboutService": "Get Support for accessing comprehensive information related to the ECIF process and tracking case statuses seamlessly through ECIF Support Services",
        "dataverseRowID": "45c58a6b-cad7-ef11-a72f-000d3a36150e",
        "service_IsActive": true,
        "service_IsDropdownUI": false,
        "service_IsNonIRISService": false,
        "service_IsPrivate": false,
        "serviceDropDownLinks": null,
        "serviceRequestFormLink": "[{\"RequestTypeName\":\"Ask about Business and Compliance Reviews Related to your ECIF Case\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Ask about ECIF Policy, Eligibility and Guidance\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Ask about Purchase Orders or Supplier Change\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Ask about Workscope Documentation and Related Information\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Information about Milestones\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Information Related to Suppliers, Invoices, PoE or Closure\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Request Business Support from Deal Desk or Others\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Request ECIF Case Extension\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Request ECIF Pre-Approvals\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Request Help on Programs or Compliance\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Request Help with Submitting an ECIF Case\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Request Milestone Change\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Request OneAsk Tool Access\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Request Procurement Support (ESXP Related)\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Request Supplier Status or Supplier Change\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Request Support on Supplier Selection\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Request Technical Support Related to Workscope\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Requests Related to Invoices\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Requests Related to Proof of Execution (PoE)\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Requests Related to Purchase Order (PO)\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Requests Related to Revenue Recognition\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Requests Related to SAP Revenue or ECIF Consumption Reports\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Review Upcoming Milestones\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false}]",
        "openinBrowserTab": false,
        "relatedInformation": null,
        "serviceCategories": null,
        "service_IsLarge": 0,
        "upn": "99731051-a822-e911-a824-000d3a31272e",
        "displayName": "Stephanie Wilson",
        "faqLink": null,
        "irisAppName": "mcapsv2",
        "requestTypeName": null,
        "defaultloadtile": false,
        "isSegment": false
    },
    {
        "id": 52189,
        "userID": 31162,
        "serviceID": 64,
        "iriS_Utterance": null,
        "tileName": "Microsoft Customer Engagement Methodology (MCEM)",
        "name": "Microsoft Customer Engagement Methodology (MCEM)",
        "aboutService": "Get Support for sales cycle tactics with Microsoft Customer Engagement Methodology (MCEM). Utilize a proven framework for success",
        "dataverseRowID": "7c3eac10-cbd7-ef11-a72f-000d3a5be227",
        "service_IsActive": true,
        "service_IsDropdownUI": false,
        "service_IsNonIRISService": false,
        "service_IsPrivate": false,
        "serviceDropDownLinks": null,
        "serviceRequestFormLink": null,
        "openinBrowserTab": false,
        "relatedInformation": null,
        "serviceCategories": null,
        "service_IsLarge": 0,
        "upn": "3de6d199-49ab-ea11-a812-000d3a35b29b",
        "displayName": "Abhishek Kumar",
        "faqLink": "https://microsoft.sharepoint.com/sites/MCAPSHelp/SitePages/MCEM_v2.aspx",
        "irisAppName": "mcapsv2",
        "requestTypeName": null,
        "defaultloadtile": false,
        "isSegment": false
    },
    {
        "id": 52188,
        "userID": 31162,
        "serviceID": 40,
        "iriS_Utterance": null,
        "tileName": "MSX Insights",
        "name": "MSX Insights",
        "aboutService": "Get Support for insights and analytics, get access to data and reports related to Sales and Finance within Microsoft through MSX Insights",
        "dataverseRowID": "4ca7c426-cbd7-ef11-a72f-00224806b545",
        "service_IsActive": true,
        "service_IsDropdownUI": false,
        "service_IsNonIRISService": false,
        "service_IsPrivate": false,
        "serviceDropDownLinks": null,
        "serviceRequestFormLink": null,
        "openinBrowserTab": false,
        "relatedInformation": null,
        "serviceCategories": null,
        "service_IsLarge": 0,
        "upn": "c4a7d782-b61f-e911-a823-000d3a31272e",
        "displayName": "Michael Yuan",
        "faqLink": null,
        "irisAppName": "mcapsv2",
        "requestTypeName": null,
        "defaultloadtile": false,
        "isSegment": false
    },
    {
        "id": 52191,
        "userID": 31162,
        "serviceID": 111,
        "iriS_Utterance": "Tool & Report Access Request",
        "tileName": "Tool and Report Access Requests",
        "name": "Tool & Report Access Requests",
        "aboutService": "Get Support for accessing self-help tools and reports including MS Sales, MSX D365 CRM, and more",
        "dataverseRowID": "e4fedef2-cbd7-ef11-a72f-000d3a5be227",
        "service_IsActive": true,
        "service_IsDropdownUI": false,
        "service_IsNonIRISService": false,
        "service_IsPrivate": false,
        "serviceDropDownLinks": null,
        "serviceRequestFormLink": "[{\"RequestTypeName\":\"Agreement Management\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Billing Group\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Business Insights\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"CompassOne\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Concur\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Connected Customer Experience (CCE)\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Connected Customer Experience (CCE) Digital Experience\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Customer Success Portfolio\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Enterprise Services Experience (ESXP)\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"FIPS Expense\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Global Partner Solutions (GPS) CRM\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Global Partner Solutions (GPS) Insights\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"GPS Cube Access\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"GPSMART (Non PII)\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"GPSMART PII\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Integrated Sales Planning (ISP)\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Labor Management (Time 2.0)\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Lynx\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Microsoft Sales Compensation (MSC)\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Microsoft Sales Experience (MSX) Content Hub\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Microsoft Sales Experience (MSX) Dynamics 365\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Microsoft Sales Experience (MSX) Insights\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"MS Sales\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"My Incentives (MINT)\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Offerings Management (Phoenix)\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"One Service Estimator (OSE)\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Partner Master Views\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Profile Management (OneProfile)\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Project Delivery\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Pursuit Management\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Relationship Management (RMEx)\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Resource Management (GRM)\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Sales Performance Management (SPM)\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"SAP\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Services Hub\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Tools Not Listed Here\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Unified Support Pricing (USP)\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Virtuoso\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Worldwide Incentive Compensation (WWIC) Participation Report Access in Microsoft Sales Compensation (MSC)\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false}]",
        "openinBrowserTab": false,
        "relatedInformation": null,
        "serviceCategories": null,
        "service_IsLarge": 0,
        "upn": "3de6d199-49ab-ea11-a812-000d3a35b29b",
        "displayName": "Abhishek Kumar",
        "faqLink": null,
        "irisAppName": "mcapsv2",
        "requestTypeName": null,
        "defaultloadtile": false,
        "isSegment": false
    },
    {
        "id": 52190,
        "userID": 31162,
        "serviceID": 75,
        "iriS_Utterance": null,
        "tileName": "WWIC Seller",
        "name": "WWIC Services (inquiries only)",
        "aboutService": "Get Support for Worldwide Incentive Compensation inquiries and issues to ensure on time and accurate compensation",
        "dataverseRowID": "8b5fa31f-ccd7-ef11-a72f-000d3a35c3b5",
        "service_IsActive": true,
        "service_IsDropdownUI": false,
        "service_IsNonIRISService": false,
        "service_IsPrivate": false,
        "serviceDropDownLinks": null,
        "serviceRequestFormLink": "[{\"RequestTypeName\":\"Access Related Issues\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Corporate, External, and Legal Affairs Data Request\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Issues Related to HR Data\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Issues Related to Incentive Target Amount\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Issues With Manager Reports\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Issues With Seller Reports\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Missing Refresh Dates\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Missing Transition Allowance\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Plan Understanding Information Request\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Request Account Based Quota Relief Information\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Request Data for Internal Audit\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Request Disputed Payout Related Information\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Request Eligibility Information\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Request Manual Quota Adjustment Information\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Request Manual Revenue Adjustment Information\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Request Missing or Negative Revenue Information\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Request Multiplier or Modifier Information\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Request Participant Plan Agreement Information\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Request Payment Calculations Information\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Request Payout Not Received Related Information\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Request Quota Acknowledgement Information\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Request Quota Management Information\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Request Quota Processes and Timelines Information\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Request Recovery Related Information\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Request Seller Data\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Request Terms & Conditions Information\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Request Unexpected Quota Change Information\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false},{\"RequestTypeName\":\"Request Zero Quota or Target Information\",\"ServiceRequestFormLink\":null,\"OpeninBrowserTab\":false}]",
        "openinBrowserTab": false,
        "relatedInformation": null,
        "serviceCategories": null,
        "service_IsLarge": 0,
        "upn": "513fd1ef-8522-e911-a824-000d3a31272e",
        "displayName": "Ryan Donnell",
        "faqLink": null,
        "irisAppName": "mcapsv2",
        "requestTypeName": null,
        "defaultloadtile": false,
        "isSegment": false
    }
];


  useEffect(() => {
    setCards(mockData);
    checkParam();
  }, []);

  const handleDelete = (serviceID) => {
    setCards((prevCards) =>
      prevCards.filter((card) => card.serviceID !== serviceID)
    );
  };


  const checkParam = () => {

    const urlParams = new URLSearchParams(window.location.search);
    const tileName = urlParams.get("TileName");
    const irisUtterance = urlParams.get("IRISUtterance");

    if (tileName === "Digital Win Room (DWR)" && irisUtterance === "Digital Win Room (DWR)") {
      const dwrCard = mockData.find((card) =>
        card.tileName.includes("Digital Win Room (DWR)")
      );
      if (dwrCard) {
        setSelectedCard(dwrCard);
        setDefaultTab("form"); // Set default tab to 'form'
        setModalVisible(true);
      }
    }
  };


  const toggleExpand = (serviceID: number) => {
    setExpandedCards((prevExpandedCards) => {
      return {
        ...prevExpandedCards,
        [serviceID]: !prevExpandedCards[serviceID],
      };
    });
  };

  const getCardsCountFromUrl = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const cardsCount = parseInt(urlParams.get("tilecount") || "5", 10); // Default to 5 if not present
    return cardsCount;
  };




  const cardsToDisplay = cards.slice(0, getCardsCountFromUrl());

  //   const fetchData = async () => {
  //     try {
  //       const response = await getConsumptionAPI(
  //         `/api/V2_UserWorkSpace/GetAllWorkspaces/${userId}`,
  //         context.authClient
  //       );


  //       const extractedData = response.data.reduce((acc, item) => {
  //         if (item.tileName && item.serviceID) {
  //           acc.push({
  //             tileName: item.tileName,
  //             serviceID: item.serviceID,
  //             aboutService: item.aboutService,
  //             displayName: item.displayName,
  //           });
  //         }
  //         return acc;
  //       }, []);

  //       setCards(extractedData);
  //     } catch (error) {
  //       console.error("Error fetching data:", error);
  //     }
  //   };

  //   useEffect(() => {
  //     fetchData();
  //   }, [userId, context.authClient]);
  // Close the MCAPS Copilot panel if open so tile click isn't consumed by light-dismiss overlay
  const closeMCAPSPanel = () => {
    try {
      if (document.body.classList.contains('mcaps-panel-open')) {
        window.dispatchEvent(new CustomEvent('mcapsCopilot_requestClose'));
      }
    } catch { }
  };

  const handleCardClick = (card) => {
    closeMCAPSPanel();
    setSelectedCard(card);
    setModalVisible(true);
    setDefaultTab("service");

   
    reduxDispatch(settitleLoaderName(card.tileName));
    reduxDispatch(setIsLoader(true));
    reduxDispatch(setIsBotError(false));
    setShowBot(false);
    if (card.tileName == "Digital Win Room (DWR) Help" || card.iriS_Utterance ==  "Americas Requests")  {
      setIrisUtterance("");
    }
    else{
      setIrisUtterance(card.iriS_Utterance);
    }
    setIrisAppName("mcapsv2");
    setTileName(card.tileName);
    setChatBotClicked(true)

  };

  const reduxDispatch = useDispatch();

  const setActiveTabKeyinMain = (activeKey) => {
    setActiveTabKey(activeKey);
  }

  const GotoCatalogPage = async () => {
    // Start Event Logging //
    reduxDispatch(
      SETLogEventData({
        elementName: "Add more Help to My Help Workspace",
        elementId: "",
        action: "click",
        message: "User click on Add more Help to My Help Workspace",
        profileSetting: `v2`,
      })
    );
    reduxDispatch(SETIsCustomeLog(true));
    // End Event Logging //
    setActiveTabKeyinMain("1");
  };

  const handleCloseModal = () => {
    setModalVisible(false);
    setSelectedCard(null);
    setDefaultTab("service");
  };




  return (
    <div className={styles.section}>
      <Text className={styles.sectionTitle}>My Help</Text>
      <div className={styles.container}>
        {cardsToDisplay.length > 0 ? (
          cardsToDisplay.map((card, index) => (
            <CardElements
              key={card.serviceID || index}
              title={card.tileName}
              aboutService={card.aboutService}
              displayName={card.displayName}
              isExpanded={!!expandedCards[card.serviceID]}
              toggleExpand={() => toggleExpand(card.serviceID)}
              onDelete={() => handleDelete(card.serviceID)}
              onClick={() => handleCardClick(card)}
            />
          ))
        ) : (
          <p>No help available</p>
        )}
        <div className={styles.findMoreCard} onClick={GotoCatalogPage}>Find more Help</div>
      </div>

      {selectedCard && (
        <CardModal
          isVisible={modalVisible}
          onClose={handleCloseModal}
          cardDetails={selectedCard}
          defaultTab={defaultTab}
        />
      )}
    </div>
  );
};

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    gap: "20px",
    padding: "20px",
  },
  headerconatiner: {
    display: "flex",
    flexDirection: "column",
    gap: "5px",
    flex: 1, // Allow this section to grow based on content
    overflow: "visible", // Allow overflow to be visible and prevent clipping
    paddingBottom: "10px", // Add padding at the bottom to allow extra space for description
  },
  leftColumn: {
    marginTop: "20px",
    flex: 1,
    maxHeight: "100px", // Limit height for the left column
    overflow: "hidden", // Prevent overflow
  },
  section: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    width: "100%",
    margin: "0px auto",
    padding: "50px",
  },
  sectionTitle: {
    fontSize: "20px",
    fontWeight: "bold",
    marginLeft: "25px",
  },
  findMoreCard: {
    width: "300px",
    height: "180px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "1px dashed #ccc",
    borderRadius: "12px",
    cursor: "pointer",
    textAlign: "center",
  },
  cardcomp: {
    borderTopWidth: "4px",
    width: "320px",
    maxWidth: "100%",
    padding: "16px",
    border: "1px solid rgb(239, 239, 239)",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    backgroundColor: "#ffffff",
    borderTopColor: "rgb(0, 120, 212)",
    borderBlockWidth: "4px",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    height: "auto", // Allow card height to adjust based on content
    maxHeight: "600px", // Set max height to avoid cards becoming too large
    overflow: "hidden", // Hide overflow content if necessary
    "&::before, &::after": {
      content: "none !important",
      border: "none !important",
      outline: "none !important",
      boxShadow: "none !important",
    },
    transition: "box-shadow 0.3s ease-in-out",
    "&:hover": {
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
      backgroundColor: "white",
    },
  },
  title: {
    fontSize: "18px",
    fontWeight: "bold",
    overflowWrap: "break-word", // Allow long words to break and wrap to the next line
    wordBreak: "break-word",    // Break words if needed, to avoid overflow
    whiteSpace: "normal",       // Allow title text to wrap normally
    lineHeight: "1.4",          // Provide some spacing between lines of text
  },
  description: {
    fontSize: "14px",
    color: tokens.colorNeutralForeground2,
    display: "-webkit-box", // Use a flex container with multiple lines
    WebkitBoxOrient: "vertical", // Set to vertical for multi-line text
    overflow: "hidden", // Hide overflow content
    WebkitLineClamp: 2, // Limit the text to 2 lines
    whiteSpace: "normal", // Allow wrapping of text
    textOverflow: "ellipsis", // Add ellipsis (...) if the content overflows
    cursor: "pointer", // Change cursor on hover to indicate interactivity
    marginTop: "5px", // Optional: Add some space between the title and description
    "&:hover": {
      WebkitLineClamp: "unset", // Remove line clamping on hover to show the full description
      whiteSpace: "normal", // Allow text to wrap completely on hover
      textOverflow: "unset", // Remove ellipsis on hover
    },
  },

  infoSection: {
    fontSize: "12px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "20px",
    flex: 1,
    maxHeight: "100px", // Limit height for this section
    overflow: "hidden", // Prevent overflow
    marginTop: "10px",
  },
  rightColumn: {
    display: "flex",
    justifyContent: "flex-end",
  },
  leftColSla: {
    borderTop: "1px solid #000",
    paddingTop: "10px",
    flex: 1,
    maxHeight: "60px", // Limit height for this section
  },
  iconImage: {
    width: "120px",
    height: "80px",
  },
  actionButton: {
    borderRadius: "20px",
    fontSize: "12px",
    padding: "4px 10px",
    backgroundColor: tokens.colorNeutralBackground3,
    border: "1px solid #ccc",
    marginBottom: "10px",
    marginLeft: "40px",
  },
  actionconatiner: {
    borderTop: "1px solid #000",
    paddingTop: "10px",
  },
  readMoreButton: {
    marginTop: "8px",
    color: "blue",
    cursor: "pointer",
    background: "none",
    border: "none",
    textDecoration: "underline",
  },
  deleteIcon: {
    position: "absolute",
    bottom: "1px",
    right: "10px",
    cursor: "pointer",
    fontSize: "18px",
  },
});
